import { render } from "./IndexRoot.vue?vue&type=template&id=354ac26a&scoped=true"
import script from "./IndexRoot.vue?vue&type=script&lang=js"
export * from "./IndexRoot.vue?vue&type=script&lang=js"

import "./IndexRoot.vue?vue&type=style&index=0&id=354ac26a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354ac26a"]])

export default __exports__